import api from './api';

export interface AlertSetting {
  id: string;
  userId: string;
  name: string;
  provider: string;
  budgetLimit: number;
  budgetPeriod: string;
  currentSpend: number;
  thresholdPercentage: number;
  notificationEmail: string;
  webhookUrl: string | null;
  isActive: boolean;
  lastFetchedUsage: string | null;
  periodStartDate: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAlertSettingRequest {
  name: string;
  provider: string;
  apiKey: string;
  budgetLimit: number;
  budgetPeriod: string;
  thresholdPercentage: number;
  notificationEmail: string;
  webhookUrl?: string;
}

export interface ValidateApiKeyRequest {
  provider: string;
  apiKey: string;
}

export interface ValidateApiKeyResponse {
  isValid: boolean;
  modelInfo?: {
    models?: string[];
    model?: string;
  };
}

/**
 * Get all alert settings for the current user
 */
export async function getAlertSettings(): Promise<AlertSetting[]> {
  const response = await api.get('/alert-settings');
  return response.data.data;
}

/**
 * Create a new alert setting
 */
export async function createAlertSetting(
  data: CreateAlertSettingRequest
): Promise<AlertSetting> {
  const response = await api.post('/alert-settings', data);
  return response.data;
}

/**
 * Update an existing alert setting
 */
export async function updateAlertSetting(
  id: string,
  data: Partial<CreateAlertSettingRequest>
): Promise<AlertSetting> {
  const response = await api.put(`/alert-settings/${id}`, data);
  return response.data;
}

/**
 * Delete an alert setting
 */
export async function deleteAlertSetting(id: string): Promise<void> {
  await api.delete(`/alert-settings/${id}`);
}

/**
 * Toggle alert setting active status
 */
export async function toggleAlertSetting(id: string): Promise<AlertSetting> {
  const response = await api.patch(`/alert-settings/${id}/toggle`);
  return response.data;
}

/**
 * Validate an API key
 */
export async function validateApiKey(
  data: ValidateApiKeyRequest
): Promise<ValidateApiKeyResponse> {
  const response = await api.post('/alert-settings/validate-api-key', data);
  return response.data;
}
